import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  linkButton,
  UploaderAreaOptions,
} from '../../../global-engagement.helper';
import { UploaderOptions } from '@usitsdasdesign/dds-ng/uploader';
import { GlobalEngagementsConstant } from '../../../constants/global-engagements.constants';
import { ButtonComponent, ButtonOptions } from '@usitsdasdesign/dds-ng/button';
import { ModalService } from '@usitsdasdesign/dds-ng/modal';
import { EngagementDocumentLinkComponent } from '../engagement-document-link/engagement-document-link.component';
import { EngagementDocumentUploadComponent } from '../engagement-document-upload/engagement-document-upload.component';
import { EngagementTableComponent } from '../engagement-table/engagement-table.component';
import { GlobalDocumentTableModel } from '../../../../common/models/global-engagement.model';
import { GlobalEngagementService } from '../../../../http/global-engagement/global-engagement.service';
import { SelectItemOptions } from '@usitsdasdesign/dds-ng/select';
import { PermissionsObj } from '../../../../common/models/common-models';
import { ProgressIndicatorService } from '../../../../common/services/progress-indicator.service';
@Component({
  selector: 'app-engagement-documents',
  templateUrl: './engagement-documents.component.html',
  styleUrl: './engagement-documents.component.less',
})
export class EngagementDocumentsComponent {
  @Input() submissionId: number | null = null;
  @Input() submissionStatusId: number | null = null;
  @Input() submissionTypeId: number | null | undefined = null;
  @Input() permissionObj: PermissionsObj = {} as PermissionsObj;
  @Input() isSubmissionStatusDraft: boolean = false;
  @Output() documentUploaded: EventEmitter<GlobalDocumentTableModel[]> =
    new EventEmitter<GlobalDocumentTableModel[]>();

  uploadAreaOptions: UploaderOptions = UploaderAreaOptions;
  emptyString: string = GlobalEngagementsConstant.EMPTY_STRING;
  buttonOptions: ButtonOptions = linkButton;
  isArchiveUploaded: boolean = false;
  documentTypeItemsList: SelectItemOptions[] = [];
  documentStatusItemList: SelectItemOptions[] = [];
  @Output() documentTableData: EventEmitter<GlobalDocumentTableModel[]> =
    new EventEmitter<GlobalDocumentTableModel[]>();
  @ViewChild(EngagementTableComponent)
  tableComponent!: EngagementTableComponent;

  constructor(
    private readonly modalService: ModalService,
    public readonly globalEngagementService: GlobalEngagementService,
    private readonly progressIndicatorService: ProgressIndicatorService
  ) {}

  openUploadModel(event: any, modalBtn?: ButtonComponent): void {
    this.removeBodyOverflow();
    const engagementDocumentUploadModalRef = this.modalService.open(
      EngagementDocumentUploadComponent,
      {
        isFooter: true,
        size: 'lg',
        isInverse: false,
        documentInitiatedDetails: {
          moduleName: 'GlobalEngagement',
          submissionStatusId: this.submissionStatusId,
          submissionTypeId: this.submissionTypeId,
          submissionId: this.submissionId,
          documentUploadCount: 1,
          file: event,
        },
      }
    );

    engagementDocumentUploadModalRef.onClosed().subscribe(() => {
      this.triggerDocumentTableDataApi();
      event.splice(0, event.length);
      this.progressIndicatorService.hide();
      if (modalBtn) {
        modalBtn.focus();
      }
    });
  }

  openDocumentLinkModal(modalBtn?: any): void {
    const EngagementDocumentLinkModalRef = this.modalService.open(
      EngagementDocumentLinkComponent,
      {
        documentInitiatedDetails: {
          submissionId: this.submissionId,
          moduleName: 'GlobalEngagement',
          submissionStatusId: this.submissionStatusId,
          submissionTypeId: this.submissionTypeId,
        },
      }
    );
    EngagementDocumentLinkModalRef.onClosed().subscribe(() => {
      this.triggerDocumentTableDataApi();
      this.progressIndicatorService.hide();
      if (modalBtn) {
        modalBtn.focus();
      }
    });
  }

  triggerDocumentTableDataApi(): void {
    this.tableComponent.getDocumentMetaData();
  }

  onDocumentChange(event: boolean): void {
    this.isArchiveUploaded = event;
  }

  removeBodyOverflow(): void {
    document.body.style.overflowY = 'hidden';
  }

  getAllUploadedDocuments(event: GlobalDocumentTableModel[]): void {
    this.documentTableData.emit(event);
  }
}
